import { render, staticRenderFns } from "./SideCard.vue?vue&type=template&id=75d9e267&scoped=true"
import script from "./SideCard.vue?vue&type=script&lang=js"
export * from "./SideCard.vue?vue&type=script&lang=js"
import style0 from "./SideCard.vue?vue&type=style&index=0&id=75d9e267&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75d9e267",
  null
  
)

export default component.exports